function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.6552,
  cy: 24.9033,
  r: 23.8483,
  fill: "white",
  stroke: "#5B5B5B",
  strokeWidth: 2.11
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0215 22.4838C17.959 19.8944 21.7403 18.4658 25.6562 18.4658C29.572 18.4658 33.3533 19.8944 36.2909 22.4838C36.728 22.8691 37.3946 22.8271 37.7799 22.39C38.1652 21.9529 38.1232 21.2862 37.6861 20.9009C34.3632 17.9719 30.0858 16.3558 25.6562 16.3558C21.2266 16.3558 16.9492 17.9719 13.6262 20.9009C13.1891 21.2862 13.1471 21.9529 13.5324 22.39C13.9177 22.8271 14.5844 22.8691 15.0215 22.4838ZM18.8335 26.304C20.7611 24.6985 23.1903 23.8193 25.6989 23.8193C28.2075 23.8193 30.6368 24.6985 32.5643 26.304C33.012 26.6769 33.6772 26.6162 34.0502 26.1685C34.4231 25.7208 34.3624 25.0556 33.9147 24.6827C31.608 22.7614 28.7009 21.7093 25.6989 21.7093C22.6969 21.7093 19.7898 22.7614 17.4831 24.6827C17.0354 25.0556 16.9748 25.7208 17.3477 26.1685C17.7206 26.6162 18.3858 26.6769 18.8335 26.304ZM25.6612 29.1728C24.5463 29.1728 23.459 29.5197 22.5501 30.1654C22.0751 30.5029 21.4165 30.3914 21.079 29.9164C20.7416 29.4414 20.8531 28.7828 21.3281 28.4453C22.594 27.546 24.1083 27.0628 25.6612 27.0628C27.214 27.0628 28.7284 27.546 29.9943 28.4453C30.4693 28.7828 30.5808 29.4414 30.2433 29.9164C29.9059 30.3914 29.2472 30.5029 28.7723 30.1654C27.8634 29.5197 26.7761 29.1728 25.6612 29.1728ZM25.6559 32.4202C25.0732 32.4202 24.6009 32.8925 24.6009 33.4752C24.6009 34.0579 25.0732 34.5302 25.6559 34.5302H25.6675C26.2501 34.5302 26.7225 34.0579 26.7225 33.4752C26.7225 32.8925 26.2501 32.4202 25.6675 32.4202H25.6559Z",
  fill: "#5B5B5B"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25.7066,
  height: 25.7066,
  fill: "white",
  transform: "translate(12.8027 12.0508)"
})));

var SvgWifi = function SvgWifi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWifi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wifi.029971c1.svg";
export { ForwardRef as ReactComponent };